export default __webpack_public_path__ + "static/media/pt.e3f79ff2.jpg";